import { useQuery } from '@tanstack/react-query'

// services
import API from '../services/api'

const getDatasets = async (datasetId) => {
    if (datasetId) {
        const { data } = await API.fetchDatasetById(datasetId)
        return data
    }

    return null
}

export default function useDatasetsQuery(datasetId) {
    return useQuery({
        queryKey: ['datasets', datasetId],
        queryFn: () => getDatasets(datasetId),
    })
}
